import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as authActions from './actions/';
import { setRequiresPermissionRequest, setLightRegistration, setReturnTo } from '../../redux/application/actions';
import Cookies from 'universal-cookie';
import { Switch, Route } from 'react-router-dom';
import EmailScreen from './EmailScreen';
import SelfieScreen from './SelfieScreen';
import IdentityCheck from './IdentityCheck';
import SelfIdentityCheck from './SelfIdentityCheck';
import SelfDriversLicenseCheck from './SelfDriversLicenseCheck';
import DriversLicenseCheck from './DriversLicenseCheck';
import IdentityCheckDetails from './IdentityCheckDetails';
import PersonalDetails from './PersonalDetails';
import PersonalDetailsTwo from './PersonalDetailsTwo';
import UserTermsAndConditions from './UserTermsAndConditions';
import RedirectPaymentScreen from './RedirectPaymentScreen';
import RedirectStripePaymentScreen from './RedirectStripePaymentScreen';
import ThankYou from './ThankYou';
import PaymentError from './PaymentError';
import DriversLicenseCheckDetails from './DriversLicenseCheckDetails';
import { withAlert } from 'react-alert';
import AuthService from '../../services/api/auth';
import Helper from '../../helpers';
import RegistrationStepIndicator from '../../components/RegistrationStepIndicator';
import StatusScreen from './StatusScreen';
import MultiService from './MultiService';
import ProcessApplicationScreen from './ProcessApplicationScreen';
import SubscriptionsScreen from './SubscriptionsScreen';
import PaymentScreen from './PaymentScreen';
import '../../styles/main-base.css';
import BankidScreen from './BankidScreen';
import { languageSelector } from '../../redux/application/selector';
import PromocodeScreen from './PromocodeScreen';
import PaymentCCAdyenScreen from './PaymentCCAdyenScreen';
import PaymentHandleResult from './PaymentHandleResult';
import EmailVerificationScreen from './EmailVerificationScreen';
import FiscalCodeScreen from './FiscalCodeScreen';
import SepaScreen from './SepaScreen';
const { version: regVersion } = require('../../../package.json');

const cookies = new Cookies();

const script = document.createElement('script');

class Register extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false,
        };
    }

    componentDidMount() {
        window.alert = data => {
            this.props.alert.error(window.VULOG_TRANSLATE(data));
        };

        let currentPath = this.props.location.pathname.split('/');

        let fleetId = cookies.get('fleetId');

        let urlParams = Helper.getUrlParams();
        const { language, onSetLightRegistration } = this.props;
        /**
         * check if the url contains the fleet property
         * /register/fleet_NAME
         */
        if (currentPath[currentPath.length - 1].indexOf('fleet_') === 0) {
            fleetId = currentPath[currentPath.length - 1].replace('fleet_', '');
            cookies.set('fleetId', fleetId);
        }

        if (urlParams.lang) {
            cookies.set('lang', urlParams.lang);
        } else if (language) {
            cookies.set('lang', language.substring(0, 2));
        }

        if (urlParams.serviceId) {
            cookies.set('serviceId', urlParams.serviceId);
        }
        if (urlParams.requiresPermissionRequest) {
            const { onSetRequiresPermissionRequest } = this.props;
            onSetRequiresPermissionRequest(true);
        }

        if (urlParams.light) {
            onSetLightRegistration(true);
        } else {
            onSetLightRegistration(false);
        }

        if (urlParams.returnTo) {
            const { onSetReturnTo } = this.props;
            onSetReturnTo(urlParams.returnTo);
        }

        if (!fleetId) {
            this.setState({
                loaded: true,
            });
        } else {
            AuthService.loadConfig(fleetId, cookies.get('lang'))
                .then(d => {
                    //AuthService.getAccountStatus()
                    window.SET_VULOG_DATA(d);
                    return Helper.setCalendarLocale(cookies.get('lang'));
                })
                .then(() => {
                    this.setState({
                        loaded: true,
                    });
                });
        }

        const inlineScript = document.createTextNode(
            "const historyBack = () => document.getElementById('backBtn').click(); const stopTrack = () => document.getElementById('stopTrackBtn').click();"
        );
        script.appendChild(inlineScript);
        document.body.appendChild(script);
    }

    componentDidUpdate(prevProps, prevState) {
        const { language } = this.props;
        const fleetId = cookies.get('fleetId');
        if (prevProps.language !== language) {
            AuthService.loadConfig(fleetId, cookies.get('lang'))
                .then(d => {
                    window.SET_VULOG_DATA(d);
                    return Helper.setCalendarLocale(cookies.get('lang'));
                })
                .then(() =>
                    this.setState({
                        loaded: true,
                    })
                );
        }
    }

    render() {
        if (!this.state.loaded) {
            return false;
        }
        return (
            <>
                <RegistrationStepIndicator
                    currentPosition={this.props.register.position}
                    steps={this.props.register.steps}
                />
                <Switch>
                    <Route
                        path={`${this.props.match.url}/promocode`}
                        render={props => <PromocodeScreen {...this.props} />}
                    />
                    <Route path={`${this.props.match.url}/selfie`} render={props => <SelfieScreen {...this.props} />} />
                    <Route
                        path={`${this.props.match.url}/identity-check`}
                        render={props => <IdentityCheck {...this.props} />}
                    />
                    <Route path={`${this.props.match.url}/bankid`} render={props => <BankidScreen {...this.props} />} />
                    <Route
                        path={`${this.props.match.url}/self-identity-check`}
                        render={props => <SelfIdentityCheck {...this.props} />}
                    />
                    <Route
                        path={`${this.props.match.url}/self-drivers-license-check`}
                        render={props => <SelfDriversLicenseCheck {...this.props} />}
                    />
                    <Route
                        path={`${this.props.match.url}/drivers-license-check`}
                        render={props => <DriversLicenseCheck {...this.props} />}
                    />
                    <Route
                        path={`${this.props.match.url}/identity-check-details`}
                        render={props => <IdentityCheckDetails {...this.props} />}
                    />
                    <Route
                        path={`${this.props.match.url}/services`}
                        render={props => <MultiService {...this.props} />}
                    />
                    <Route
                        path={`${this.props.match.url}/subscriptions`}
                        render={props => <SubscriptionsScreen {...this.props} />}
                    />
                    <Route
                        path={`${this.props.match.url}/drivers-license-check-details`}
                        render={props => <DriversLicenseCheckDetails {...this.props} />}
                    />
                    <Route
                        path={`${this.props.match.url}/personal-details`}
                        render={props => <PersonalDetails {...this.props} />}
                    />
                    <Route
                        path={`${this.props.match.url}/personal-details-two`}
                        render={props => <PersonalDetailsTwo {...this.props} />}
                    />
                    <Route
                        path={`${this.props.match.url}/user-terms-and-conditions`}
                        render={props => <UserTermsAndConditions {...this.props} />}
                    />
                    <Route path={`${this.props.match.url}/thank-you`} render={props => <ThankYou {...this.props} />} />
                    <Route
                        path={`${this.props.match.url}/payment-error`}
                        render={props => <PaymentError {...this.props} />}
                    />
                    <Route path={`${this.props.match.url}/status`} render={props => <StatusScreen {...this.props} />} />
                    <Route
                        path={`${this.props.match.url}/redirect-payment`}
                        render={props => <RedirectPaymentScreen {...this.props} />}
                    />
                    <Route
                        path={`${this.props.match.url}/stripe_redirection`}
                        render={props => <RedirectStripePaymentScreen {...this.props} />}
                    />
                    <Route
                        path={`${this.props.match.url}/payment`}
                        render={props => <PaymentScreen {...this.props} />}
                    />
                    <Route path={`${this.props.match.url}/sepa`} render={props => <SepaScreen {...this.props} />} />
                    <Route
                        path={`${this.props.match.url}/payment-credit-card-adyen`}
                        render={props => <PaymentCCAdyenScreen {...this.props} />}
                    />
                    <Route
                        path={`${this.props.match.url}/payment-result`}
                        render={props => <PaymentHandleResult {...this.props} />}
                    />
                    <Route
                        path={`${this.props.match.url}/process`}
                        render={props => <ProcessApplicationScreen {...this.props} />}
                    />
                    <Route
                        path={`${this.props.match.url}/email`}
                        render={props => <EmailVerificationScreen {...this.props} />}
                    />
                    <Route
                        path={`${this.props.match.url}/fiscal-code`}
                        render={() => <FiscalCodeScreen {...this.props} />}
                    />
                    <Route
                        path={`${this.props.match.url}/fleet_:fleetId/`}
                        render={props => <EmailScreen {...this.props} {...props} />}
                    />
                </Switch>
                {regVersion && <div className="release-version">{`REG v${regVersion}`}</div>}
            </>
        );
    }
}

/**
 * Get app state and pass it as props to Component
 * @param state
 * @returns {{}}
 */
function mapStateToProps(state) {
    return {
        authState: state.auth,
        register: state.register,
        language: languageSelector(state),
    };
}

const mapDispatchToProps = dispatch => ({
    onSetRequiresPermissionRequest: bindActionCreators(setRequiresPermissionRequest, dispatch),
    onSetLightRegistration: bindActionCreators(setLightRegistration, dispatch),
    onSetReturnTo: bindActionCreators(setReturnTo, dispatch),
    ...bindActionCreators(authActions, dispatch),
});

export default withAlert(connect(mapStateToProps, mapDispatchToProps)(Register));
